// This file serves as a central location for all configuration variables for Advanced Analytics Related Components
import UniversalTableConfig from "./UniversalTableConfig.js";

// TODO: MAKE SURE THAT THE DROPDOWNS ARE CONSISTENT THROUGHOUT THE ADVANCED Analytics TABS
// TODO: ^^ FROM ABOVE GET A SOLID BASIS OF THE METRICS THAT WILL BE USED / MAPPED / NOT USED
export const defaultOutlierAccordionExpand = {
  advancedFilters: false,
  vehicleFilters: false,
};
// Overview Page
// Overview: Table Columns
const overviewPerformanceDataColumns = [
  "metric",
  "value",
  "change",
  "percentage",
];

// Overview: Table Config
export const aIOverviewTableConfig = (
  handleSelectedMetric = () => {},
  selectedMetric
) => {
  // Add the columns
  const columnsConfig = overviewPerformanceDataColumns?.map((column) => {
    return {
      Header:
        column?.slice(0, 1)?.toUpperCase() +
        column?.replaceAll("_", " ")?.slice(1),
      accessor: column,
      Cell: ({ value, row }) => {
        const selectedRowClassName =
          row?.original === selectedMetric ? "ai-overview-row-selected" : "";
        const colorClassName =
          column === "metric" || row?.original?.pos
            ? ""
            : "ai-overview-row-red";
        return (
          <div
            className={`${selectedRowClassName} ${colorClassName}`}
            onClick={() => handleSelectedMetric(row?.original)}
          >
            {value}
          </div>
        );
      },
    };
  });
  return columnsConfig;
};
// Overview: Date Options Toggle (Table)
export const aiOverviewTableDateValues = ["Monthly", "Yearly"];
const aiOverviewTableInternalDateValues = ["Monthly", "Yearly"];
export const aiOverviewTableDateOptions = aiOverviewTableDateValues?.map(
  (item, index) => {
    return {
      label: item,
      value: aiOverviewTableInternalDateValues?.[index],
    };
  }
);
// AP: Chart Options
export const assetPerformanceChartValues = ["Swamp", "Bar"];
export const assetPerformanceChartOptions = assetPerformanceChartValues?.map(
  (item) => {
    return { label: item, value: item };
  }
);

// AP: Table Columns
const assetPerformanceDataColumns = ["make", "model", "year", "vehicle_count"];
// AP: Table Config
export const assetPerformanceTableConfig = (metric = "mpg") => {
  // Add the columns
  const columnsConfig = UniversalTableConfig(assetPerformanceDataColumns);

  // Add the Metric Column
  const metricColumn = [
    {
      Header:
        metric?.slice(0, 1)?.toUpperCase() +
        metric?.replaceAll("_", " ")?.slice(1),
      accessor: (universalData) => universalData?.avg_metric,
      sortValue: (universalData) => universalData?.avg_metric,
    },
  ];
  return columnsConfig?.concat(metricColumn);
};

// AP: Searchbar Options
// TODO: REVAMP THE NAMING MAPPING (ALL BELOW)
export const assetPerformanceMetricsColorMap = {
  good: ["mpg", "drivetoidle"],
  ok: ["drivetime"],
  bad: [
    "total_idle_time_hrs",
    "idle_time_emissions_by_fuel_co2_mt",
    "idle_fuel_consumed",
    // TODO: COLUMNS OUTDATED
    // "emissions_by_dist_ch4_mt",
    // "emissions_by_dist_n2o_mt",
    // "total_emissions_mt",
    // "total_s2_emissions_mt",
    "total_biogenic_emissions_mt",
    "total_fuel_consumed_gal",
  ],
};
export const assetPerformanceMetrics = Object.values(
  assetPerformanceMetricsColorMap
).flat();

export const assetPerformanceMetricsYLabelMap = {
  total_emissions_mt: "Fossil Emissions (Metric Tons)",
  mpg: "Average MPG",
  drivetime: "Total Drive Time (Hours)",
  total_idle_time_hrs: "Total Idle Time (Hours)",
  drivetoidle: "Drive to Idle Ratio",
  idle_time_emissions_by_fuel_co2_mt: "Total Idle Emissions",
  idle_fuel_consumed: "Total Idle Fuel Consumption",
  emissions_by_dist_ch4_mt: "CH₄ Emissions (kg)",
  emissions_by_dist_n2o_mt: "N₂O Emissions (kg)",
  total_fuel_consumed_gal: "Total Fuel Consumed (gal)",
  total_biogenic_emissions_mt: "Total Biogenic Emissions (Metric Tons)",
  // total_s2_emissions_mt: "Total Scope 2 Emissions (Metric Tons)",
};
export const assetPerformanceMetricsYLabelMapKeys = Object?.keys(
  assetPerformanceMetricsYLabelMap
);
export const assetPerformanceMetricColumns =
  assetPerformanceMetricsYLabelMapKeys?.map((item) => {
    return {
      label: assetPerformanceMetricsYLabelMap?.[item],
      value: item,
    };
  });

// Outlier: Good Bad Toggle
export const outlierGoodBadValues = ["bad", "good"];
export const outlierGoodBadOptions = outlierGoodBadValues?.map((item) => {
  return {
    label: item?.slice(0, 1).toUpperCase() + item?.slice(1),
    value: item,
  };
});
// Asset Performance
const outlierVehicleGroupMetrics = ["make", "model", "year", "engine"];
const outlierVehicleGroupMetricsName = [
  "Make",
  "Model",
  "Model Year",
  "Engine Model",
];
export const outlierVehicleGroupMetricLabelMap =
  outlierVehicleGroupMetrics?.reduce((acc, item, index) => {
    acc[item] = outlierVehicleGroupMetricsName?.[index];
    return acc;
  }, {});

export const outlierVehicleDetails = {
  distance: {
    label: "Distance",
    unit: "miles",
    unit2: null,
  },
  mpg: {
    label: "MPG",
    unit: null,
    unit2: null,
  },
  age: {
    label: "Age",
    unit: "years",
    unit2: null,
  },
  gallons_per_100_miles: {
    label: "Gallons per 100 Miles",
    unit: null,
    unit2: null,
  },
  gallons_per_idle_hour: {
    label: "Gallons per Idle Hour",
    unit: null,
    unit2: null,
  },
  cruise_rate: {
    label: "Cruise Rate",
    unit: "%",
    unit2: null,
  },
  idle_rate: {
    label: "Idle Rate",
    unit: "%",
    unit2: null,
  },
  over_rpm_count: {
    label: "Over RPM Count",
    unit: null,
    unit2: null,
  },
  speeding_count: {
    label: "Speeding Count",
    unit: null,
    unit2: null,
  },
  drive_time: {
    label: "Drive Time",
    unit: "hours",
    unit2: "%",
  },
  engine_run_time: {
    label: "Engine Run Time",
    unit: "hours",
    unit2: "%",
  },
  profile: {
    vehicle_id: { label: "Vehicle", unit: "" },
    vin: { label: "VIN", unit: "" },
    make: { label: "Make", unit: "" },
    year: { label: "Year", unit: "" },
    engine_type: { label: "Engine", unit: "" },
  },
};

const generalChartConfig = {
  color: "rgba(24, 83, 122, 1)",
  pointRadius: 0,
  trendline: false,
  dataValues: [],
  pos: false,
};
const generateChartConfig = (metricMapping, generalConfig) => {
  const data = Object.entries(metricMapping).reduce((acc, [key, label]) => {
    acc[key] = { label, ...generalConfig };
    return acc;
  }, {});

  return {
    loaded: false,
    data,
  };
};

// // Generate the chartConfig
const overviewMetricChartConfig = generateChartConfig(
  assetPerformanceMetricsYLabelMap,
  generalChartConfig
);

export const aiOverviewChartConfig = {
  loaded: false,
  ...overviewMetricChartConfig,
};
// Function to generate the array of dictionaries
const generateMetricArray = (metricMapping) => {
  return Object.entries(metricMapping).map(([internal, metric]) => ({
    metric,
    internal,
    value: "-",
    change: "-",
    percentage: "-",
    pos: true,
    previous_val: "-",
  }));
};

// Generate the structured array
const intialMetrics = generateMetricArray(assetPerformanceMetricsYLabelMap);

export const initialOverviewTableConfig = {
  loaded: false,
  data: {
    yearly: intialMetrics,
    monthly: intialMetrics,
  },
};
export const fleetPerformanceDataInsights = {
  good: {
    mpg: "increased",
    total_emissions_mt: "decreased",
    total_idle_time_hrs: "decreased",
    drivetime: "decreased",
    emissions_by_dist_ch4_mt: "decreased",
    emissions_by_dist_n2o_mt: "decreased",
    idle_time_emissions_by_fuel_co2_mt: "decreased",
    cruise_rate: "increased",
    scope1: "decreased",
    scope2: "decreased",
    scope3: "decreased",
    idle_time: "decreased",
    idle_fuel_consumed: "decreased",
    avg_vehicle_age: "decreased",
    avg_fuel_consumed: "increased",
    drivetoidle: "increased",
    lifecycle: "decreased",
    emissions_efficiency: "improved",
    emissions_per_idle_hour: "improved",
    fuel_card_spend: "decreased",
    industry_carbon_rating: "increased",
    base_year_reduction: "decreased",
    scope2_site: "decreased",
    total_biogenic_emissions_mt: "decreased",
    total_fuel_consumed_gal: "decreased",
  },
  bad: {
    mpg: "decreased",
    total_emissions_mt: "increased",
    total_idle_time_hrs: "increased",
    drivetime: "increased",
    emissions_by_dist_ch4_mt: "increased",
    emissions_by_dist_n2o_mt: "increased",
    idle_time_emissions_by_fuel_co2_mt: "increased",
    cruise_rate: "decreased",
    scope1: "increased",
    scope2: "increased",
    scope3: "increased",
    idle_time: "increased",
    idle_fuel_consumed: "increased",
    avg_vehicle_age: "increased",
    avg_fuel_consumed: "decreased",
    drivetoidle: "decreased",
    lifecycle: "increased",
    emissions_efficiency: "worsened",
    emissions_per_idle_hour: "worsened",
    fuel_card_spend: "increased",
    industry_carbon_rating: "decreased",
    base_year_reduction: "increased",
    scope2_site: "increased",
    total_biogenic_emissions_mt: "increased",
    total_fuel_consumed_gal: "increased",
  },
  sentence: {
    mpg: "The average MPG of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    total_emissions_mt:
      "The average Fossil Emissions of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    total_idle_time_hrs:
      "The total Idle Hours of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    drivetime:
      "The average Drive Time of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    emissions_by_dist_ch4_mt:
      "The average CH₄ Emissions of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    emissions_by_dist_n2o_mt:
      "The average N₂O Emissions of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    idle_time_emissions_by_fuel_co2_mt:
      "The average Idle Emissions of the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    cruise_rate:
      "The average time cruise control used by the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    scope1:
      "Scope 1 emissions for the fleet have [change] by [x%] from last [month/year], to [value] from [previous].",
    scope2:
      "Scope 2 emissions have [change] by [x%] from last [month/year], to [value] from [previous].",
    scope3:
      "Scope 3 emissions for the fleet have [change] by [x%] from last [month/year], to [value] from [previous].",
    idle_time:
      "Idle time for the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    idle_fuel_consumed:
      "Idle fuel consumption for the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    avg_vehicle_age:
      "The average vehicle age for the fleet has [change] from [previous] to [value], from the previous year.",
    avg_fuel_consumed:
      "Alternative fuel consumption for the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    drivetoidle:
      "The drive to idle ratio for the fleet has [change] [x%] from last [month/year], to [value] from [previous].",
    lifecycle:
      "Lifecycle emissions for the fleet have [change] by [x%] from last [month/year], to [value] from [previous].",
    emissions_efficiency:
      "The emissions efficiency of the fleet has [change] by [x%] from last [month/year], to [value] from [previous].",
    emissions_per_idle_hour:
      "The ratio of emissions per idle hour of the fleet has [change] by [x%] from last [month/year], to [value] from [previous].",
    fuel_card_spend:
      "The fuel card spend for the fleet has [change] [x%] from last [month/year], to $[value] from $[previous].",
    industry_carbon_rating:
      "The industry rating for the fleet has [change] from last [month/year], to [value] from [previous], signifying [industry_type] performance.",
    base_year_reduction:
      "Fleet emissions have [change] by [x%] from base year emissions ([base_year]), to [value] from [previous].",
    scope2_site:
      "Scope 2 emissions for [site] the fleet have [change] by [x%] from last [month/year], to [value] from [previous].",
    total_biogenic_emissions_mt:
      "The total biogenic emissions of the fleet have [change] by [x%] from last [month/year], to [value] from [previous].",
    total_fuel_consumed_gal:
      "The total fuel consumed by the fleet has [change] by [x%] from last [month/year], to [value] from [previous].",
  },
};
